import { ACTOR_IDS } from "./motion";
type CoreImage = CanvasImageSource & { width: number; height: number };
const cores = new Map<string, CoreImage>();
let requested = false;
export function setPaintedCore(id: string, image: CoreImage, back = false) {
  cores.set(id + (back ? "-back" : "-front"), image);
}
export function loadPaintedCores() {
  if (requested) return;
  requested = true;
  for (const id of ACTOR_IDS)
    for (const back of [false, true]) {
      const image = new Image();
      image.decoding = "async";
      image.onload = () => setPaintedCore(id, image, back);
      image.src = `/art/painted-cores-v6/${id}-${back ? "back" : "front"}.webp`;
    }
}
/** Rigid body artwork with independent joint limbs; never deform or stretch a whole actor. */
export function drawPaintedCore(
  ctx: CanvasRenderingContext2D,
  id: string,
  x: number,
  bottom: number,
  height: number,
  back: boolean,
) {
  const image = cores.get(id + (back ? "-back" : "-front"));
  if (!image) return false;
  const width = (height * image.width) / image.height;
  ctx.drawImage(image, x - width / 2, bottom - height, width, height);
  return true;
}
